export default {
  componentName: 'AvailabilityFilter',
  fr: {
    label: 'Disponibilités',
    placeholder: 'Toutes',
    all: 'Toutes les disponibilités',
    showResultsWithT07Avails: '7 prochains jours',
    showResultsWithTa7Avails: 'Dans plus de 7 jours',
    showResultsWithNoAvails: 'Sans disponibilités',
    ariaLabel:
      'Filtrer par disponibilités. Liste déroulante réduite, {1} sur {2}. Option {0} sélectionnée. Pour changer la sélection, appuyez sur entrer, puis utilisez flèche haut et bas. Appuyez sur entrer pour confirmer la sélection.',
    ariaLabelMobile:
      'Filtrer par disponibilités. Groupe de boutons radio {1} sur {2}. Option {0} sélectionnée. Utilisez bas et haut pour naviguer.',
    ariaLabelItemSelected: '{0}. Sélectionné. Option {1} sur {2}',
    ariaLabelItemUnselected: '{0}. Non sélectionné. Option {1} sur {2}',
    optionsDescription: 'Liste déroulante de 3 options, ouverte.',
    optionsDescriptionMobile: '3 boutons radio.'
  },
  en: {
    label: 'Availabilities',
    placeholder: 'All',
    all: 'Show all availabilities',
    showResultsWithT07Avails: 'Next 7 days',
    showResultsWithTa7Avails: 'In more than 7 next days',
    showResultsWithNoAvails: 'No availability',
    ariaLabel:
      'Filter by availabilities. Combobox closed, {1} of {2}. Option {0} selected. To change the selection, press Enter, then use the up and down arrow. Press Enter to confirm the selection.',
    ariaLabelMobile:
      'Filter by availabilities. Radio buttons group, {1} of {2}. Option {0} selected. Use the up and down to navigate.',
    itemOnly: '{0} only',
    ariaLabelItemSelected: '{0}. Selected. Option {1} of {2}',
    ariaLabelItemUnselected: '{0}. Not selected. Option {1} of {2}',
    optionsDescription: 'Combobox of 3 options, open.',
    optionsDescriptionMobile: '3 radio buttons.'
  }
}
